import { useLayoutEffect, type RefObject } from 'react';

/** Grows a textarea with its content up to `maxHeightPx`, then lets it scroll. */
export function useAutoResizeTextarea(
  ref: RefObject<HTMLTextAreaElement>,
  value: string,
  maxHeightPx: number
) {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    element.style.height = 'auto';
    element.style.height = `${Math.min(element.scrollHeight, maxHeightPx)}px`;
    element.style.overflowY = element.scrollHeight > maxHeightPx ? 'auto' : 'hidden';
  }, [ref, value, maxHeightPx]);
}
